import { cn } from "@/utils/cn";
import React, { forwardRef } from "react";

const GradientOutline = forwardRef(
  ({ children, className, filled, error, flat }, ref) => {
    const border = className?.match(/border-[^\s]+/g);

    return (
      <div
        ref={ref}
        className={cn(
          "w-full h-full rounded-7 from-[#2E6ABD] via-[#F84160] to-[#009900]",
          {
            "bg-opacity-20 bg-[#000E25] hover:bg-gradient-to-r hover:bg-opacity-100 focus-within:bg-gradient-to-r focus-within:bg-opacity-100":
              !filled && !error && !flat,
            "bg-gradient-to-r": filled && !flat,
            "text-[#AE1C28]": error,
            "bg-[#AE1C28] bg-opacity-100": error && !flat,
          },
          className
        )}
      >
        <div
          className={cn(
            "w-full h-full rounded-7 border !border-transparent bg-clip-padding",
            {
              "": flat,
              "bg-white": !flat,
            },
            border
          )}
        >
          {children}
        </div>
      </div>
    );
  }
);

export default GradientOutline;
